import { storeToRefs } from 'pinia'
import { useTaskProfiles } from '../../store/useTaskProfiles'
import { RecapResponsesModel } from '../../models/RecapReponsesModel'
import { logInfo } from '../../utils'
import { unref } from 'vue'

/**
 * Only return values needed to update for a task, rather than entire task,
 * as a task is a join of several tables.
 */
export const getCompletedTasksData = () => {
  const { getEditedTasks } = storeToRefs(useTaskProfiles())
  if (getEditedTasks.value.length < 1) {
    return null
  }
  const editedTasks = unref(getEditedTasks.value)

  // Defer getting any tasks missing recaps so the sync can continue
  setTimeout(async () => {
    const tasksMissingRecap = []
    for (const task of editedTasks) {
      if (task.bulk_updated) {
        // The task was bulk-updated
        continue
      }
      // Check if we have a recap for the task
      const { getRecapResponseExistsForTask } = RecapResponsesModel()
      const exists = await getRecapResponseExistsForTask(task.task_id)
      if (!exists) {
        // Flag the task as missing a recap if one doesn't exist and it wasn't bulk updated
        tasksMissingRecap.push(task)
        continue
      }
    }

    // Let Sentry know if we're missing any recaps
    if (tasksMissingRecap.length) {
      logInfo('error', 'TaskSync', 'Tasks missing recap responses', {
        taskIds: tasksMissingRecap.map((task) => task.task_id),
        tasks: tasksMissingRecap,
      })
    }
  })

  // Sync the task data
  return editedTasks.map((task) => {
    const {
      task_id,
      execution_latitude,
      execution_longitude,
      task_status_id,
      rai_code,
      rai_reason_code,
      ads_installed,
      quantity_installed,
      quantity_reason_code,
      bundles_added,
      pieces_remaining,
      placement_instruction_sequence,
      task_comments,
      executed_at,
    } = task

    return {
      ...(task_id && { id: task_id }),
      ...(execution_latitude && { execution_latitude }),
      ...(execution_longitude && { execution_longitude }),
      ...(task_status_id && { status_id: task_status_id }),
      ...(rai_code && { rai_code }),
      ...(rai_reason_code && { rai_code_reason_id: rai_reason_code }),
      ...(ads_installed && { ads_installed }),
      ...(quantity_installed && { quantity_installed }),
      ...(quantity_reason_code && { quantity_reason_code }),
      ...(bundles_added && { bundles_added }),
      ...(pieces_remaining && { pieces_remaining }),
      ...(placement_instruction_sequence && { placement_instruction_sequence }),
      ...(task_comments && { task_comments }),
      ...(executed_at && { executed_at }),
    }
  })
}
